import React, { useState } from "react";
import EventListView from "./EventListView";
import { ApiHook } from "../../hooks/apiHook";
import TablePagination from "../Common/table/TablePagination";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const LeadTrackTable = ({
  leadList,
  funnalStages,
  setEventModalData,
  onEvnetsClick,
  eventsList,
  stepId,
}) => {
  const [showModal, setModal] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [eventId, setEventId] = useState();
  const [eventStatus, setEventStatus] = useState(1);
  const [leadId, setLeadId] = useState();
  const queryClient = useQueryClient();

  const eventListModal = (eventId, leadId, stepId, eventStatus) => {
    onEvnetsClick(leadId, stepId);
    setEventId(eventId);
    setModal(true);
    setEventStatus(eventStatus);
    setLeadId(leadId);
  };
  const handleClose = () => {
    setModal(false);
  };

  const leadListData = ApiHook.CallCrmList(currentPage, itemsPerPage);
  const addLeadstatusMutation = ApiHook.AddLeadStatusChange();

  const toNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const toLastPage = () => {
    setCurrentPage(leadListData?.data?.totalPages);
  };

  const toPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const toFirstPage = () => {
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (event) => {
    const selectedValue = parseInt(event.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1);
  };
  const onStageoptionChange = (event, leadId,currentStage) => {
    addLeadstatusMutation.mutate(
      { leadStatus: event.target.value, leadId: leadId ,currentStage:currentStage },
      {
        onSuccess: (res) => {
          console.log("statgeupdatereposnoe",res)
          if (res.status) {
            toast.success("Sales stage updated");
            queryClient.invalidateQueries({ queryKey: ["crm-list"] });
          } else {
            toast.error(res?.description);
          }
        },
      }
    );
  };

  return (
    <div className="joining_Teammbr_section">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12">
          <div className="crm_panel_body__31wq1 pannel-sec">
            <div className="crm_table_responsive__cut_1 table-responsive">
              <table className="table follow-up-table">
                <thead>
                  <tr className="th" align="center">
                    <th>#</th>
                    <th>Lead Name</th>
                    <th>Current Stage</th>
                    <th>Description</th>
                    <th>Event Description</th>
                    <th>Change Stage</th>
                    <th>Event Action (Add or Update)</th>
                    <th>Event Details</th>
                  </tr>
                </thead>
                <tbody>
                  {leadListData &&
                    leadListData?.data?.data?.map((obj, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{(obj["firstName"] ?? "") + " " + (obj["lastName"] ?? "")}</td>


                        <td>{obj["salesFunnelStage.name"]}</td>
                        <td>{obj["salesFunnelStage.description"]}</td>
                        <td>{obj["salesFunnelStage.eventDescription"]}</td>
                        <td align="center">
                          <div class="custom-select">
                            <select
                              onChange={(e) => onStageoptionChange(e, obj.id,obj["salesFunnelStage.id"])}
                              value={obj["salesFunnelStage.id"]}
                            >
                              {funnalStages?.map((funnalObj) => (
                                <option
                                  value={funnalObj?.id}
                                  disabled={!(funnalObj?.id >= obj["salesFunnelStage.id"])}
                                >
                                  {funnalObj?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                        <td>
                          {obj["salesFunnelStage.eventStatus"] === 1 ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                              }}
                            >
                              <i
                                className="fa fa-plus-square"
                                style={{
                                  fontSize: "20px",
                                  marginRight: "10px",
                                }}
                                onClick={() =>
                                  setEventModalData(
                                    obj?.id,
                                    obj["salesFunnelStage.id"]
                                  )
                                }
                              ></i>
                            </div>
                          ) : obj["salesFunnelStage.eventStatus"] === 2 ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                              }}
                            >
                              {/* <div>
                                <i
                                  className="fa fa-plus-square"
                                  style={{
                                    fontSize: "20px",
                                    marginRight: "10px",
                                  }}
                                  onClick={() =>
                                    setEventModalData(
                                      obj?.id,
                                      obj["salesFunnelStage.id"]
                                    )
                                  }
                                ></i>
                              </div> */}
                              <i
                                className="fa-regular fa-pen-to-square"
                                style={{ fontSize: "20px" }}
                                onClick={() =>
                                  eventListModal(
                                    1,
                                    obj?.id,
                                    obj["salesFunnelStage.id"],
                                    obj["salesFunnelStage.eventStatus"]
                                  )
                                }
                              ></i>
                            </div>
                          ) : (
                  

                            <></>
                          )}
                        </td>
                        <td>
                            <div>
                              <i
                                className="fa fa-eye"
                                style={{
                                  fontSize: "20px",
                                  marginRight: "10px",
                                }}
                                onClick={() =>
                                  eventListModal(
                                    "",
                                    obj?.id,
                                    obj["salesFunnelStage.id"],
                                    obj["salesFunnelStage.eventStatus"]
                                  )
                                }
                              ></i>
                            </div>
                  
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {leadListData?.data?.data?.length > 0 && (
                <TablePagination
                  startPage={1}
                  currentPage={currentPage}
                  totalPages={leadListData?.data?.totalPages}
                  itemsPerPage={itemsPerPage}
                  toNextPage={toNextPage}
                  toLastPage={toLastPage}
                  toPreviousPage={toPreviousPage}
                  toFirstPage={toFirstPage}
                  handleItemsPerPageChange={handleItemsPerPageChange}
                />
              )}
            </div>
            <EventListView
              show={showModal}
              handleClose={handleClose}
              eventsList={eventsList}
              eventId={eventId}
              stepId={stepId}
              eventStatus={eventStatus}
              leadId={leadId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadTrackTable;
